import { apiSlice } from '../../../core/api/apiSlice';

export interface KnowledgeDocument {
  id: string;
  organization_id: string;
  uploaded_by: string | null;
  uploader_name: string | null;
  uploader_email: string | null;
  title: string;
  description: string | null;
  file_name: string;
  file_url: string | null;
  file_size: number | null;
  file_type: string | null;
  category: string | null;
  created_at: string | null;
  updated_at: string | null;
}

interface ListResponse {
  success: boolean;
  message: string;
  data: KnowledgeDocument[];
}

interface SingleResponse {
  success: boolean;
  message: string;
  data: KnowledgeDocument;
}

export const knowledgeApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    listKnowledgeDocs: builder.query<ListResponse, { organization_id?: string, sort?: string } | void>({
      query: (arg) => {
        let url = '/knowledge';
        const params = new URLSearchParams();
        if (arg?.organization_id) {
          params.append('organization_id', arg.organization_id);
        }
        if (arg?.sort) {
          params.append('sort', arg.sort);
        }
        if (params.toString()) {
          url += `?${params.toString()}`;
        }
        return url;
      },
      providesTags: ['KnowledgeDocs'],
    }),

    uploadKnowledgeDoc: builder.mutation<
      SingleResponse,
      { formData: FormData }
    >({
      query: ({ formData }) => ({
        url: '/knowledge',
        method: 'POST',
        body: formData,
        formData: true,
      }),
      invalidatesTags: ['KnowledgeDocs'],
    }),

    updateKnowledgeDoc: builder.mutation<
      SingleResponse,
      { id: string; title?: string; description?: string; category?: string }
    >({
      query: ({ id, ...body }) => ({
        url: `/knowledge/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['KnowledgeDocs'],
    }),

    deleteKnowledgeDoc: builder.mutation<
      { success: boolean; message: string; data: null },
      string
    >({
      query: (id) => ({
        url: `/knowledge/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['KnowledgeDocs'],
    }),
  }),
});

export const {
  useListKnowledgeDocsQuery,
  useUploadKnowledgeDocMutation,
  useUpdateKnowledgeDocMutation,
  useDeleteKnowledgeDocMutation,
} = knowledgeApi;
